import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../types";

export const selectComplianceState = (state: RootState) =>
  state.complianceState;

export const selectCompliance = createSelector(
  selectComplianceState,
  (state) => state.compliance
);
